import React from 'react';
import './AboutModal.css';

/**
 * AboutModal Component
 * 
 * Modal component for the "About" information that opens when clicking the About link
 */
const AboutModal = ({ isOpen, onClose }) => {
  // Close the modal when clicking outside
  const handleOutsideClick = (e) => {
    if (e.target.className.includes('modal')) {
      onClose();
    }
  };
  
  // Use the uploaded profile image
  const profileImagePath = '/images/profile.jpg';

  return (
    <div 
      id="myModal" 
      className={`modal ${isOpen ? 'modal-open' : 'modal-closed'}`}
      onClick={handleOutsideClick}
    >
      {/* Modal content */}
      <div className="modal-content">
        <span className="close" onClick={onClose}>&times;</span>

        <h2>Welcome to my Portfolio & Toolkit</h2>

        <div className="marc-background">
          <img 
            src={profileImagePath} 
            className="marc" 
            alt="Marc Lee"
          />
        </div>

        <p>
          Hi. Thank you for taking the time to look at my product portfolio and toolkit. The case studies that can be found on this site aim to showcase my varied skillset - from starting something from scratch, to taking a brief and creating a new product, to improving an existing solution. 
        </p>

        <p>
          The toolkit contains a set of frameworks, templates, methodologies, resources and tools that I have come across and collated - I created this originally as a means of organising myself and my process in order to rapidly develop products and decided to put it online as a quick access resource for myself, and my peers. 
        </p>

        <p>
          As someone that has always seen themselves as entrepreneurial and innovative, I've found software to be the perfect medium to explore ideas and innovate and invent new things - whether commercially focused, or user focused.           
        </p>
        
        <p>
          I consider my skill set to be a Product Manager / User Experience Designer hybrid - having a full understanding of the business goals and commercial needs, but with an uncompromising focus on the ultimate User Experience.   
        </p>

        <h4>Contact</h4>
        <p>
          If you have a project or something else you would like to discuss then feel free to email me (&#104;&#101;&#108;&#108;&#111;&#064;&#109;&#097;&#114;&#099;&#046;&#108;&#121;) or you can find me on LinkedIn <a className="link" href="https://www.linkedin.com/in/marchenrylee/">here</a>.
        </p>
      </div>
    </div>
  );
};

export default AboutModal; 